import { GiphyApi } from 'api'
import { GiphyResponse } from 'types/giphy'

const GIPHY_RATING = 'pg'

// https://developers.giphy.com/docs/optional-settings/#language-support
const SUPPORTED_LANGS = [
  'en',
  'es',
  'pt',
  'id',
  'fr',
  'ar',
  'tr',
  'th',
  'vi',
  'de',
  'it',
  'ja',
  'zh-CN',
  'zh-TW',
  'ru',
  'ko',
  'pl',
  'nl',
  'ro',
  'hu',
  'sv',
  'cs',
  'hi',
  'bn',
  'da',
  'fa',
  'tl',
  'fi',
  'iw',
  'ms',
  'no',
  'uk'
]

const localeToGiphyLang = locale => {
  switch (locale) {
    case 'de-DE-formal':
      return 'de'

    case 'zh':
      return 'zh-CN'

    case 'zh-HK':
      return 'zh-TW'

    case 'pt-BR' || 'pt-PT':
      return 'pt'

    default:
      break
  }

  if (SUPPORTED_LANGS.includes(locale)) {
    return locale
  }

  return 'en'
}

export const getTrendingGiphys = (limit: number) =>
  GiphyApi.get<GiphyResponse>('/trending', {
    params: {
      limit,
      rating: GIPHY_RATING
    }
  })

export const getSearchGiphys = (queryTerms: string, limit: number, { locale }: { locale?: string } = {}) =>
  GiphyApi.get<GiphyResponse>('/search', {
    params: {
      limit,
      q: queryTerms,
      lang: localeToGiphyLang(locale),
      rating: GIPHY_RATING
    }
  })
